import React from "react";

const SuccessMessage = ({ successMessage }) => (
    <span className="success-message">{successMessage}</span>
);

export default SuccessMessage;
